module.exports = __webpack_public_path__ + "static/liva-sm-0aef3a6d95794670a13e5bd42f0f729a.jpg";